export default {
  index: [
    {
      path: '/GoodsDictionary',
      component: resolve => require(['./GoodsDictionaryIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/GoodsDictionary/_router.js